export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}
export interface userDetails {
  user_type: string;
  id: number;
}

export interface commonPaginationTypes {
  token?: string;
  after: string | null;
  first: number | null;
}

export interface pageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
}

export interface commonMutationTypes {
  token?: string;
  user_details: userDetails;
}

export interface nodeVar {
  id: number;
  token?: string;
}

export type GetByAuthIdVars = {
  token: string;
  auth_id: number;
};
